import { render } from "./IconSecurity.vue?vue&type=template&id=3c9d2c17"
import script from "./IconSecurity.vue?vue&type=script&lang=js"
export * from "./IconSecurity.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__